import axios from '../../config/axios';
import getEnv from '../getEnv';

const context = getEnv('redecredenciada');

interface ISearchEcs {
  distance: string;
  lat: string;
  lon: string;
  radius: string;
  product: string;
  term: string;
  delivery: boolean;
}

export default {
  searchEcs: async (params: ISearchEcs) => {
    let data;

    try {
      const response = await axios.get(`${context}/search/buscaec`, { params });

      data = response?.data;
    } catch (e) {
      const errorMessages = { messages: e.response?.data?.messages };
      throw errorMessages;
    }

    return data;
  },
};
